import React, { Component } from "react";
import { bool, shape } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";

import Enviroments from "pages/_components/Enviroments";
import Button from "pages/_components/Button";
import { Mixpanel } from "util/clickstreaming";
import LoginFooter from "pages/onboarding/footer";
import Logo from "./Logo";

const FORM_ID = "login.step3";

class Step3Content extends Component {
    static propTypes = {
        fetching: bool,
        environments: shape([]).isRequired,
        isDesktop: bool.isRequired,
    };

    static defaultProps = {
        fetching: false,
    };

    render() {
        const { environments, fetching, isDesktop } = this.props;

        return (
            <Form className="above-the-fold login-desktop-wrapper select-environment container--layout">
                {isDesktop && (
                    <div className="text-center mb-5">
                        <Logo className="svg-image logo-large" />
                    </div>
                )}
                <h1 className="text-center">
                    <I18n
                        id="login.step3.environment.title"
                        defaultValue="Elegí el perfil de usuario con el que vas a operar"
                    />
                </h1>
                <Field
                    name="environment"
                    environments={environments}
                    component={Enviroments}
                    disabled={fetching}
                    legendTextID="login.step3.environment.required"
                    fromSetDefaultEnvironmentPage={false}
                />
                {/* <Field name="rememberEnvironment" idForm={FORM_ID} component={SwitchField} formGroup /> */}
                <div className="form-actions">
                    <Button type="submit" loading={fetching} label="login.nextStep" bsStyle="primary" />
                </div>
                <LoginFooter />
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    environments: Object.entries(loginSelectors.getEnvironments(state)),
    fetching: loginSelectors.getFetching(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: () => ({ environment: "", rememberEnvironment: false }),
        validationSchema: () =>
            Yup.object().shape({
                environment: Yup.string().required(i18n.get(`${FORM_ID}.environment.required`)),
            }),
        handleSubmit: ({ environment, rememberEnvironment }, formikBag) => {
            Mixpanel.track(FORM_ID, { environment, rememberEnvironment });
            formikBag.props.dispatch(loginActions.loginStep3(environment, rememberEnvironment, formikBag));
        },
    }),
)(Step3Content);
